import type React from "react"
import { useTranslation } from "react-i18next"

import { RightPanelCloseIcon } from "@/components/mui-icons/RightPanelCloseIcon"
import { RightPanelOpenIcon } from "@/components/mui-icons/RightPanelOpenIcon"

import { Button } from "@mui/material"

interface SiteInfoButtonProps {
  isOpen: boolean
  onClick: () => void
}

export const SiteInfoButton: React.FC<SiteInfoButtonProps> = ({
  isOpen,
  onClick,
}) => {
  const { t } = useTranslation()

  return (
    <Button
      color="neutral"
      endIcon={isOpen ? <RightPanelCloseIcon /> : <RightPanelOpenIcon />}
      onClick={onClick}
      size="small"
    >
      {t("site.info.buttonLabel", { ns: "sites" })}
    </Button>
  )
}
